import { Component, OnInit, Input, Output, EventEmitter, ViewChildren, QueryList, ElementRef, Inject, OnDestroy, Renderer2 } from '@angular/core';
import { Router } from "@angular/router";
import { Subscription } from 'rxjs';
import { MatDialogRef, MatDialog } from '@angular/material';

import { config } from '../../../../../config/index';

import { AdminDashboardService } from '../../../dashboard/admin-dashboard/admin-dashboard.service';
import { TCDashboardService } from '../../../dashboard/tc-dashboard/tc-dashboard.service';
import { ActionRequiredListServcie } from './action-required.service';
import { SessionStorageService } from '../../services/session-storage.service';
import { SnackbarService } from '../../services/snackbar.service';
import { TooltipService } from '../../services/tooltip.service';
import { RestrictOutsideScrollService } from '../../services/restrict-outside-scroll.service';
import { LogoutService } from '../../../logout/logout.service';

import { LtrErrorPopupComponent } from '../ltr-error-popup/ltr-error-popup.component';
import { FollowUpEmail } from '../modal/follow-up-email/follow-up-email.component';
import { FollowUpSms } from '../modal/follow-up-sms/follow-up-sms.component';

@Component({
    selector: 'action-required',
    template: require('./action-required.component.html'),
    styles: [require('./action-required.component.less')],
    providers: [ActionRequiredListServcie, AdminDashboardService, TCDashboardService, TooltipService, SnackbarService, RestrictOutsideScrollService, SessionStorageService, LogoutService],
    preserveWhitespaces: true
})

export class ActionRequiredListComponent implements OnInit, OnDestroy {
    @Input() actionRequiredItems: any;
    @Input() userRole: any;

    @Output() closeActionRequiredList = new EventEmitter<any>();
    @Output() pendingItemCount = new EventEmitter<any>();

    @ViewChildren('datePicker') datePicker: QueryList<ElementRef>

    sendTriggerText: string = 'SEND_SELECTED';
    headerItems: any;
    headerItemsCOO: any = ['PATIENT_NAME', 'TREATMENT_COORDINATOR', 'LOCATION', 'PATIENT_GROUP', 'TREATMENT_FEE', 'QUOTE', 'DAYS_PENDING', 'ACTION'];
    headerItemsTC: any = ['TYPE', 'AUTOMATION', 'PATIENT_NAME', 'LOCATION', 'TRIGGER', 'OVER_DUE', 'BEST_METHOD', 'CONTACT', 'ACTIONS'];
    apiResponse: any = [];
    apiResponseTotalCount: number = 0;
    togglePermissions: any;
    listLoaded: boolean = false;
    showTooltip: boolean = false;
    loading: boolean = false;
    loadingList: boolean = false;
    displayMessage: string;
    consultation_type_names: any = {
        consultation_followup: 'Consultation',
        virtual_consultation_followup: 'Virtual Consult',
        patient_ortho_followup: 'Patient Relapse',
        parent_ortho_followup: 'Parent Relapse',
        patient_referral_followup: 'Referral',
        non_start_tracking_followup: 'Non Start Consult'
    };
    togglePermissionKeys: any = {
        consultation_followup: 'is_quote_automated',
        virtual_consultation_followup: 'is_quote_automated',
        patient_ortho_followup: 'is_patient_relapse_automated',
        parent_ortho_followup: 'is_parent_relapse_automated',
        patient_referral_followup: 'is_patient_referral_automated',
        non_start_tracking_followup: 'is_non_start_automated'
    }
    orthoUrl: any;
    actionItemsArray: any = [];

    followupListCommunicationArray: any = [];

    apiSubscriptions: Subscription[] = [];
    approveTreatmentSubscription: Subscription;
    followupSubscription: Subscription;
    cancelTrackingApiSubscription: Subscription;
    getPatientApiSubscription: Subscription;
    presentVirtualPlanApiSubscription: Subscription;

    utilServiceSubscriptions: Subscription[] = [];

    dialogRefLtrErrorPopup: MatDialogRef<LtrErrorPopupComponent>;
    dialogRefSms: MatDialogRef<FollowUpSms>;

    itemLimit: number = 20;

    allCheckboxModel: boolean = false;
    selectedItemsArray: any = [];
    selectedItemsCount: number;
    selectAllActionItems: boolean = false;

    sortParam: string;
    sortParams: any = ['followup_type', 'overdue_days'];
    sortParamsConfig: any = [];
    order: string;

    actionListShowPosition: string;
    showAutomationColumn: boolean;

    dialogRefEmail: MatDialogRef<FollowUpEmail>;

    constructor(
        private _actionRequiredListService: ActionRequiredListServcie,
        private _router: Router,
        private _adminDashboardService: AdminDashboardService,
        private _tcDashBoardService: TCDashboardService,
        private _sessionStorageService: SessionStorageService,
        private _mdlSnackbarService: SnackbarService,
        private _restrictOutsideScrollService: RestrictOutsideScrollService,
        public dialog: MatDialog,
        private _logoutService: LogoutService,
        private _tooltipService: TooltipService,
        private renderer: Renderer2,
        @Inject("utilService") private utilService: any
    ) {
        this.utilServiceSubscriptions.push(this.utilService.actionRequiredListPageUpdated.subscribe(this.changesOnPageUpdate));
    }

    changesOnPageUpdate = (data: any) => {
        if (data.update) {
            this.close();
        } else {
            this.loading = false;
        }
    }

    setActionListShowPosition(index: number) {
        let actionListTopOffset = document.getElementById('actionListContainer' + index).getBoundingClientRect().top;
        let actionListRelativeToBottomOffsetPercentage = (window.innerHeight - actionListTopOffset) / window.innerHeight * 100;

        this.actionListShowPosition = actionListRelativeToBottomOffsetPercentage < 30 ? 'upwards' : 'downwards';
    }

    getSortParam(header_string: string) {
        return header_string === 'TYPE' ? 'followup_type' : 'overdue_days';
    }

    // for sorting
    sort(param: any) {
        this.sortParam = param;

        if (this.sortParamsConfig[param].firstToggle) {
            this.sortParamsConfig[param].firstToggle = false;
        } else {
            this.sortParamsConfig[param].sortDescending = !this.sortParamsConfig[param].sortDescending;
        }

        for (let sort_param of this.sortParams) {
            if (sort_param !== param) {
                this.sortParamsConfig[sort_param].firstToggle = true;
            }
        }
        this.order = this.sortParamsConfig[param].sortDescending ? 'des' : 'asc';

        this.initTC(true);
    }

    navigateToPatientAdd() {
        this.loading = true;

        if (window.location.href.indexOf('patient-file-add') === -1) {
            this._router.navigate(["patient/patient-file-add"]);
        } else {
            this.utilService.samePageUpdateByActionRequiredList.next({ update: true });
        }
    }

    createPatientFile(listData: any) {
        if (listData.followup_type === 'parent_ortho_followup') {
            let from_parent_relapse: any = {};
            from_parent_relapse['treatment_plan_id'] = listData.treatment_plan;
            from_parent_relapse['followup_type'] = 'parent_ortho_followup';
            this._sessionStorageService.saveItem('from_parent_relapse', from_parent_relapse);
            this._sessionStorageService.saveItem('viewPatientId', 'add').then((data: any) => {
                this.navigateToPatientAdd();
            })
        } else if (listData.followup_type === 'patient_referral_followup' || listData.followup_type === 'virtual_consultation_followup') {
            this._sessionStorageService.saveItem("viewPatientId", listData).then((data: any) => {
                this.navigateToPatientAdd();
            })
        }
    }

    createTreatmentPlan(listData: any) {
        if (listData.patient_file) {
            this.loading = true;
            let patient_file_id = parseInt(listData.patient_file);
            this.getPatientApiSubscription?.unsubscribe();
            this.getPatientApiSubscription = this._tcDashBoardService.getPatientFile(patient_file_id)
                .subscribe((res: any) => {
                    res.data.patient_file_id = patient_file_id;
                    res.data.existing_relation = 'EXISTING_PATIENT';
                    res.data.patient_relaspse_treatment_id = listData.id;
                    this._sessionStorageService.saveItem('viewPatientId', res.data).then(
                        data => this._router.navigate(['patient/treatment-plan'])
                    );
                    this.loading = false;
                },
                    (error: any) => {
                        this._mdlSnackbarService.showSnackbar('SOMETHING_WENT_WRONG', 'error');
                        this.loading = false;
                    });
        }
    }

    createVirtualTreatmentPlan(virtualAppointmentData: any) {
        if (virtualAppointmentData.patient_file) {
            this.loading = true;
            this.getPatientApiSubscription?.unsubscribe();
            this.getPatientApiSubscription = this._tcDashBoardService
                .getPatientFile(virtualAppointmentData.patient_file)
                .subscribe(
                    (res: any) => {
                        res.data.patient_file_id =
                            virtualAppointmentData.patient_file;
                        res.data.virtual_plan = true;
                        this._sessionStorageService
                            .saveItem("viewPatientId", res.data)
                            .then((data) =>
                                this._router.navigate([
                                    "patient/treatment-plan",
                                ])
                            );
                        this.loading = false;
                    },
                    (error: any) => {
                        this._mdlSnackbarService.showSnackbar(
                            "SOMETHING_WENT_WRONG", 'error'
                        );
                        this.loading = false;
                    }
                );
        }
    }

    changeVirtualToTxPlan(listData: any) {
        this.presentVirtualPlanApiSubscription = this._tcDashBoardService
            .virtualPlanPresent(
                listData.treatment_plan
            )
            .subscribe(
                (res: any) => {
                    this.presentPlan(listData);
                },
                (error: any) => {
                    this._mdlSnackbarService.showSnackbar(
                        "SOMETHING_WENT_WRONG", 'error'
                    );
                }
            )
        ;
    }

    setOrthoUrl(patient_url: any, key: any) {
        this.orthoUrl = window.open("", "_blank");
        this.orthoUrl.document.write("Loading...");
        this.orthoUrl.location.href =
            patient_url +
            "?startnow=true" +
            "&key=" +
            key;
    }

    presentPlan(virtualAppointmentData: any) {
        if (virtualAppointmentData.treatment_plan_id) {
            this.loading = true;
            this.apiSubscriptions.push(this._tcDashBoardService
                .getTreatmentPlan(
                    virtualAppointmentData.treatment_plan_id
                )
                .subscribe(
                    (res: any) => {
                        const dobDigits = res.data.patient_file.patient.dob.split('-').join('');
                        const contactNumberdigits = res.data.patient_file.patient.contact_number.split('+').join('');
                        const key = (dobDigits + contactNumberdigits).replace(/ /g,'');
                        this.loading = false;
                        this.setOrthoUrl(res.data.patient_url, key);
                        this.apiSubscriptions.push(this._logoutService.logout().subscribe(
                            (res: any) => {
                                window
                                    .open("about:blank", "_parent", "")
                                    .close();
                            },
                            (error) => {
                                this._router.navigate(["logout"]);
                            }
                        ));
                    },
                    (error: any) => {
                        this._mdlSnackbarService.showSnackbar(
                            "SOMETHING_WENT_WRONG", 'error'
                        );
                        this.loading = false;
                    }
                )
            );
        }
    }

    postponeConfirm(index: number) {
        let id = this.apiResponse[index]?.related_data?.original_instance_id;
        this.actionItemsArray = [this.apiResponse[index].id];

        this.followupListCommunicationArray = [{
            original_id: id,
            followup_type: this.apiResponse[index]?.followup_type
        }];

        let data = {
            postpone_to: this.apiResponse[index].postpone_to
        }

        this.loading = true;
        this._tcDashBoardService.postponeFollowup(data, id)
            .subscribe((res: any) => {
                this.loadListAfterAction();
                this.loading = false;
                this._mdlSnackbarService.showSnackbar('POSTPONE_SUCCESS', 'success');
            },
                (error: any) => {
                    this.loading = false;
                    this._mdlSnackbarService.showSnackbar('UPDATE_POSTPONE_DATE_FAIL', 'error');
                });
    }


    cancelTracking(cancelTrackingItem: any) {
        let cancelTrackingId = cancelTrackingItem?.related_data?.original_instance_id,
            item_followup_type = cancelTrackingItem.followup_type;
        this.actionItemsArray = [cancelTrackingItem.id];

        this.followupListCommunicationArray = [{
            original_id: cancelTrackingId,
            followup_type: cancelTrackingItem.followup_type
        }];

        this.loading = true;
        this.cancelTrackingApiSubscription?.unsubscribe();

        if (item_followup_type === "consultation_followup") {
            this.cancelTrackingApiSubscription = this._tcDashBoardService
                .cancelTracking(cancelTrackingId)
                .subscribe(
                    (res: any) => {
                        this.cancelTrackingSuccess();
                    },
                    (error: any) => {
                        this.cancelTrackingError();
                    }
                );
        } else if (item_followup_type === "virtual_consultation_followup") {
            this.cancelTrackingApiSubscription = this._tcDashBoardService
                .cancelVirtualTracking(cancelTrackingId)
                .subscribe(
                    (res: any) => {
                        this.cancelTrackingSuccess();
                    },
                    (error: any) => {
                        this.cancelTrackingError();
                    }
                );
        } else if (item_followup_type === "patient_referral_followup") {
            this.cancelTrackingApiSubscription = this._tcDashBoardService
                .deleteRefPatientService(cancelTrackingId)
                .subscribe(
                    (res: any) => {
                        this.cancelTrackingSuccess();
                    },
                    (error: any) => {
                        this.cancelTrackingError();
                    }
                );
        } else if (item_followup_type === "parent_ortho_followup") {
            this.cancelTrackingApiSubscription = this._tcDashBoardService
                .deleteRelapseService(
                    cancelTrackingId,
                    "parent_relapse_communications"
                )
                .subscribe(
                    (res: any) => {
                        this.cancelTrackingSuccess();
                    },
                    (error: any) => {
                        this.cancelTrackingError();
                    }
                );
        } else if (item_followup_type === "patient_ortho_followup") {
            this.cancelTrackingApiSubscription = this._tcDashBoardService
                .deleteRelapseService(
                    cancelTrackingId,
                    "patient_relapse_communications"
                )
                .subscribe(
                    (res: any) => {
                        this.cancelTrackingSuccess();
                    },
                    (error: any) => {
                        this.cancelTrackingError();
                    }
                );
        } else if (item_followup_type === "non_start_tracking_followup") {
            this.cancelTrackingApiSubscription = this._actionRequiredListService
                .cancelNonStartFollowupTracking(
                    cancelTrackingId
                )
                .subscribe(
                    (res: any) => {
                        this.cancelTrackingSuccess();
                    },
                    (error: any) => {
                        this.cancelTrackingError();
                    }
                );
        }
    }

    cancelTrackingSuccess() {
        this.loading = false;
        this.loadListAfterAction();
        this._mdlSnackbarService.showSnackbar(
            "TRACKING_CANCELLED", 'success'
        );
    }

    cancelTrackingError() {
        this.loading = false;
        this._mdlSnackbarService.showSnackbar(
            "SOMETHING_WENT_WRONG", 'error'
        );
    }

    updateAutomation(listData: any) {
        this.loading = true;
        this._actionRequiredListService.updateAutomation(listData.id, listData.automatic_trigger)
            .subscribe(res => {
                this.loading = false;
                this._mdlSnackbarService.showSnackbar('AUTOMATIC_TRIGGER_UPDATED', 'success');
            },
                error => {
                    this.loading = false;

                    if (error.error_code === 321) {
                        this._mdlSnackbarService.showSnackbar('DATA_SYNC_ERROR_AUTOMATION', 'error');
                        this.initTC(true);
                    } else {
                        this._mdlSnackbarService.showSnackbar('SOMETHING_WENT_WRONG', 'error');
                        listData.automatic_trigger = !listData.automatic_trigger;
                    }
                });
    }

    openSmsPreview(data: any) {
        data['section'] = data.followup_type;
        if (data['section'] === 'consultation_followup') {
            data['section'] = 'follow-up';
        }
        data['method'] = 'text';
        data['fromSection'] = 'action_required_list';
        this._sessionStorageService.saveItem('textDetails', data).then(() => {
            this.dialogRefSms = this.dialog.open(FollowUpSms, {
                panelClass: 'sms-editor-popup-wrap',
            });
            const actionRequiredListContainer = document.querySelector('#actionRequiredListContainer');
            if (actionRequiredListContainer) {
                this.renderer.setStyle(actionRequiredListContainer, 'display', 'none');
            }
            this._restrictOutsideScrollService.hideBackgroundScroll();
            const smsComponentInstance = this.dialogRefSms.componentInstance;
            if (smsComponentInstance) {
                smsComponentInstance.smsActionCompleted.subscribe(() => {
                    this.actionItemsArray = [data.id];
                    this.followupListCommunicationArray = [{
                        original_id: data?.related_data?.original_instance_id,
                        followup_type: data?.followup_type,
                    }];
                    this.loadListAfterAction();
                });
            }
            this.dialogRefSms.afterClosed().subscribe(result => {
                if (actionRequiredListContainer) {
                    this.renderer.setStyle(actionRequiredListContainer, 'display', 'flex');
                }
            })
        })
    }

    sendTrigger(list_item?: any, trigger_type?: string) {
        let reqData: any;

        if (list_item && list_item.opt_in_status === 'rejected' && trigger_type === 'text') {
            return;
        }

        if (!list_item) {
            if (this.selectAllActionItems) {
                reqData = {
                    ids: 'all',
                };

                this.followupListCommunicationArray = ['all'];
            } else {
                reqData = {
                    ids: this.selectedItemsArray,
                    method: 'default'
                };

                this.followupListCommunicationArray = this.apiResponse.filter((item: any) => this.selectedItemsArray.includes(item.id))
                    .map((filtered_item: any) => ({ original_id: filtered_item?.related_data?.original_instance_id, followup_type: filtered_item?.followup_type}));
            }

            this.actionItemsArray = this.selectedItemsArray;
        } else {
            let item_id = list_item?.id;

            reqData = {
                ids: [item_id],
                method: trigger_type
            }

            this.actionItemsArray = [item_id];
            this.followupListCommunicationArray = [{
                original_id: list_item?.related_data?.original_instance_id,
                followup_type: list_item?.followup_type
            }];
        }

        this.loading = true;
        this._actionRequiredListService.sendTrigger(reqData)
            .subscribe(res => {
                this.loading = false;
                this._mdlSnackbarService.showSnackbar('TRIGGER_SENT', 'success');
                this.loadListAfterAction();
            },
                error => {
                    this.loading = false;
                    this._mdlSnackbarService.showSnackbar('SOMETHING_WENT_WRONG', 'error');
                });
    }

    approvalListSuccessHandler(response: any) {
        this.loading = false;
        this.listLoaded = true;
        this.apiResponse = response.data;
        if (!this.apiResponse.length) {
            this.displayMessage = 'NO_ACTION_ITEMS';
        }
        this.apiResponseTotalCount = response.count;
        this.pendingItemCount.emit(this.apiResponseTotalCount);
        this.apiResponse.forEach((approvalList: any) => {
            approvalList.currencySymbol = config.currency[approvalList.currency];
        });
    }

    approveTreatment(id: any) {
        this.actionItemsArray = [id];
        this.loading = true;
        this.approveTreatmentSubscription?.unsubscribe();
        this.approveTreatmentSubscription = this._adminDashboardService.approveTreatment(id)
            .subscribe((res: any) => {
                this.loading = false;
                this._sessionStorageService.saveItem('approval_from_action_required_list', true);
                this._sessionStorageService.saveItem('approval_from_url', window.location.pathname).then(
                    data => {
                        if (res.data.errorCode === 'ENVELOPE_DOES_NOT_EXIST') {
                            this._mdlSnackbarService.showSnackbar('ENVELOPE_DOES_NOT_EXIST', 'error');
                        } else {
                            window.location.href = res.data.url;
                        }
                    }
                );
            },
                error => {
                    if (error?.error_code === 321) {
                        this.openLTRErrorPopup(id);
                    } else if (['PLAN_STARTED', 'PLAN_DECLINED', 'INVALID_TX_PLAN_ID'].indexOf(error.message) !== -1) {
                        this._mdlSnackbarService.showSnackbar(error.message, 'error');
                        this.apiResponse = this.apiResponse.filter((item: any) => item.id !== id);
                    } else {
                        this._mdlSnackbarService.showSnackbar('SOMETHING_WENT_WRONG', 'error');
                    }
                    this.loading = false;
                });

    }

    openLTRErrorPopup(planId: number) {
        this._restrictOutsideScrollService.hideBackgroundScroll();

        this.dialogRefLtrErrorPopup = this.dialog.open(LtrErrorPopupComponent, {
            disableClose: true,
            data: {
                planId: planId,
            },
        });

        this.dialogRefLtrErrorPopup?.afterClosed().subscribe(result => {
            if (result === 'revived') {
                // this.initCOO(true);
                this.loadListAfterAction();
            }
            this._restrictOutsideScrollService.showBackgroundScroll();
        });
    }

    setOverDueColorForVirtual(patient: any) {
        switch (true) {
            case patient.overdue_days > 0:
                return "status-colorR"
            case patient.overdue_days == 0:
                return "status-colorY"
            case patient.overdue_days < 0:
                return "status-colorG";
        }
    }

    setOverDueColor(patient: any) {
        switch (true) {
            case patient.overdue_days > 0:
                return "status-colorR"
            case patient.overdue_days == 0:
                return "status-colorY"
            case patient.overdue_days < 0:
                return "status-colorG";
        }
    }

    overDueSort = (data: any[], vc?: any, from_parent_relapse?: any) => {
        data.forEach((patient) => {
            // if (from_parent_relapse === true) {
            //     patient.idName = "phone" + patient.id;
            // } else {
            //     patient.idName = patient?.patient?.id ? "phone" + patient.patient.id : "phone" + patient.patient_id;
            // }
            if (vc === true) {
                if (patient.vc_status === "virtual_treatment_plan_selected") {
                    patient.className = "status-colorB";
                } else {
                    patient.className = this.setOverDueColorForVirtual(patient);
                }
            } else {
                patient.className = this.setOverDueColor(patient);
            }

            if (patient.opt_in_status === "accepted") {
                patient.phoneClassName = "material-icons phone-icon-green";
            } else if (patient.opt_in_status === "rejected") {
                patient.phoneClassName = "material-icons phone-icon-red";
            } else {
                patient.phoneClassName = "material-icons phone-icon-grey";
            }
        });
    };

    openPicker(userData: any, i: any) {
        if (document.activeElement instanceof HTMLInputElement) {
            document.activeElement.blur();
        }
        setTimeout(this.datePicker['_results'][0].instance.show, 150);
    }

    OpenActionList(index: any) {
        this.apiResponse?.forEach((element: any, i = 0) => {
            if (i === index) {
                element.openActionListFlag = !element.openActionListFlag;
            } else {
                element.openActionListFlag = false;
            }
        });
    }

    onClickOutside(eve: any, index: any) {
        if (document.getElementsByClassName('mbsc-fr-scroll').length <= 0) {
            if (eve && eve.target.className.indexOf('dot-btn') === -1 && eve.target.className.indexOf('postpone') === -1) {
                this.apiResponse[index].openActionListFlag = false;
            }
        }
    }

    onOutsideClick(event: any) {
        const allowedClasses = ['dot-btn', 'action-required-icon', 'badge', 'sort-icon', 'select-all', 'selected-items-info-section', 'capitalize-letter', 'arrow-icon'];
        const targetClassList = event.target.className.split(' ');

        const isAllowed = targetClassList.some((className: any) => allowedClasses.includes(className));

        if (!event.target.closest('.action-required-list-container')
                && !event.target.closest('.follow-up-preview')
                && !event.target.closest('.cdk-overlay-container')
                && !isAllowed) {
            if (!event.target.classList?.contains('arrow-icon')) {
                this.closeActionRequiredList.emit(true);
            }
        }
    }

    viewPatient = (data: any) => {
        this.loading = true;
        this._sessionStorageService.saveItem("viewPatientId", data).then((data: any) => {
            if (window.location.href.indexOf('patient-file-view') === -1) {
                this._router.navigate(["patient/patient-file-view"]);
            } else {
                this.utilService.samePageUpdateByActionRequiredList.next({ update: true });
            }
        });
    };

    goToPatientFile(list: any) {
        if (list.patient_file) {
            let viewData = JSON.parse(JSON.stringify(list));
            viewData.id = list.patient_file;
            this.viewPatient(viewData);
        }
    }

    followUpCommunicationSuccessHandler = (response: any) => {
        this.overDueSort(response.data);
        this.apiResponse = response.data;
        this.togglePermissions = response.extra?.toggle_permission;
        this.setShowAutomationColumn();
        this.allCheckboxModel = false;
        this.selectedItemsCount = 0;
        this.selectedItemsArray = [];
        if (!this.apiResponse.length) {
            this.displayMessage = 'NO_ACTION_ITEMS';
        }
        this.apiResponseTotalCount = response.count;
        this.pendingItemCount.emit(this.apiResponseTotalCount);
        this.apiResponse.forEach((listData: any) => {
            if (listData.followup_type === 'consultation_followup') {
                const today = new Date();
                const formattedDate = new Intl.DateTimeFormat('en-US', { timeZone: listData.time_zone }).format(today);
                const currentDateInTimeZone = new Date(formattedDate);
                const tomorrow = new Date(currentDateInTimeZone);
                tomorrow.setDate(currentDateInTimeZone.getDate() + 1);
                const day = tomorrow.getDate();
                const year = tomorrow.getFullYear();
                const month = tomorrow.getMonth() + 1;
                const nextDayDate = month + "/" + day + "/" + year;
                listData.min_date = nextDayDate;
                const nextYear = new Date().getFullYear() + 1;
                const firstDayOftheYear = new Date(nextYear + "-01-01");
                listData.postpone_to = firstDayOftheYear;
            }
            listData.openActionListFlag = false;
        });
    };

    setShowAutomationColumn() {
        this.showAutomationColumn = Object.values(this.togglePermissions).indexOf(true) !== -1;
    }

    checkAllActionItems() {
        this.checkAll(true);
        this.selectAllActionItems = true;
        this.sendTriggerText = 'SEND_ALL';
    }

    checkAll(event: any) {
        this.apiResponse.forEach((item: any, index: number) => {
            item.selected = event;
            this.checkItem(event, index, true);
        });

        if (this.selectedItemsCount === this.apiResponseTotalCount) {
            this.selectAllActionItems = true;
            this.sendTriggerText = 'SEND_ALL';
        }
    }

    checkItem(event: any, index: number, fromCheckAll?: boolean) {
        if (this.selectAllActionItems && !(fromCheckAll && event)) {
            this.selectAllActionItems = false;
        }

        let itemIndex = this.selectedItemsArray.indexOf(this.apiResponse[index].id);

        if (event && itemIndex === -1) {
            this.selectedItemsArray.push(this.apiResponse[index].id);
            if (this.selectedItemsArray.length === this.apiResponse.length) {
                this.allCheckboxModel = true;
            }
        } else if (!event) {
            this.selectedItemsArray.splice(itemIndex, 1);
            if (this.allCheckboxModel) {
                this.allCheckboxModel = false;
            }

            if (this.sendTriggerText === 'SEND_ALL') {
                this.sendTriggerText = 'SEND_SELECTED';
            }
        }

        this.selectedItemsCount = this.selectedItemsArray.length;

        if (!fromCheckAll && (this.selectedItemsCount === this.apiResponseTotalCount)) {
            this.selectAllActionItems = true;
            this.sendTriggerText = 'SEND_ALL';
        }
    }

    initTC(scrollToTop?: boolean) {
        this.loading = true;
        this.followupSubscription?.unsubscribe();
        this.followupSubscription = this._actionRequiredListService
            .followUpCommunicationService(this.itemLimit, 0, this.sortParam, this.order)
            .subscribe(
                (res) => {
                    this.loading = false;
                    this.listLoaded = true;
                    this.followUpCommunicationSuccessHandler(res);

                    if (scrollToTop && document.getElementById("infinite-scroll-tc")) {
                        document.getElementById("infinite-scroll-tc").scrollTop = 0;
                    }
                },
                (error: any) => {
                    this.loading = false;
                    this.listLoaded = true;
                    this._mdlSnackbarService.showSnackbar('SOMETHING_WENT_WRONG', 'error');
                }
            );
    }

    close() {
        this.closeActionRequiredList.emit(true);
    }

    initCOO(reload?: boolean) {
        this.loading = true;
        let reqLimit = reload ? this.apiResponse.length : this.itemLimit;

        this._actionRequiredListService.approvalListService(reqLimit, 0)
            .subscribe(res => this.approvalListSuccessHandler(res),
                error => {
                    this.loading = false;
                    this.listLoaded = true;
                    this.displayMessage = 'SOMETHING_WENT_WRONG';
                });
    }

    loadMessagesOnScroll() {
        this.appendToList(this.itemLimit, this.apiResponse.length);
    }

    loadListAfterAction() {
        this.apiResponse = this.apiResponse.filter((item: any) => this.actionItemsArray.indexOf(item.id) === -1);
        this.selectedItemsArray = this.selectedItemsArray.filter((id: any) => !this.actionItemsArray.includes(id));
        this.selectedItemsCount = this.selectedItemsArray.length;

        this.utilService.pageListUpdateFromActionRequiredList.next({splice_list: this.followupListCommunicationArray});

        this.appendToList(this.actionItemsArray.length, this.apiResponse.length);
    }

    appendToList(limit: number, offset: number) {
        if (this.apiResponse.length < this.apiResponseTotalCount) {
            this.loadingList = true;

            if (this.userRole === 'COO Admin' || this.userRole === 'Location Manager') {
                this._actionRequiredListService.approvalListService(limit, offset)
                    .subscribe(res => {
                        this.loadingList = false;
                        this.apiResponse = this.apiResponse.concat(res.data);
                        this.apiResponseTotalCount = res.count;
                        this.pendingItemCount.emit(this.apiResponseTotalCount);

                        if (!this.apiResponse.length) {
                            this.displayMessage = 'NO_ACTION_ITEMS';
                        }
                    },
                        error => {
                            this.loadingList = false;
                            this.displayMessage = 'SOMETHING_WENT_WRONG';
                        });
            } else {
                this._actionRequiredListService.followUpCommunicationService(limit, offset, this.sortParam, this.order)
                    .subscribe(res => {
                        this.loadingList = false;
                        res.data.forEach((listData: any) => {
                            listData.min_date = new Date().toISOString();
                            listData.postpone_to = new Date();
                            listData.openActionListFlag = false;
                        });
                        this.apiResponse = this.apiResponse.concat(res.data);
                        this.apiResponseTotalCount = res.count;
                        this.togglePermissions = res.extra?.toggle_permission;
                        this.setShowAutomationColumn();
                        this.pendingItemCount.emit(this.apiResponseTotalCount);

                        if (!this.apiResponse.length) {
                            this.displayMessage = 'NO_ACTION_ITEMS';
                        }

                        if (this.allCheckboxModel) {
                            this.checkAll(true);
                        }
                        this.overDueSort(this.apiResponse);
                    },
                        error => {
                            this.loadingList = false;
                            this.displayMessage = 'SOMETHING_WENT_WRONG';
                        });
            }
        }
    }

    subscriptionAccessAllowed(userRole: any) {
        if (userRole.subscription_status === 'expired' || userRole.pending_payment?.type === 'restrict'
            || !userRole.subscription_status
            || userRole.subscription_status === 'initial_pending'
            || userRole.subscription_status !== 'active'
            || (userRole.subscription_status === 'active' && !userRole.is_ses_email_verified)) {
            return false;
        }

        return true;
    }

    openEmailPreview(followupData: any) {
        followupData['section'] = followupData.followup_type;
        followupData['method'] = 'email';
        followupData['communication_id'] = followupData.communication_id;
        followupData['id'] = followupData.id;
        followupData['fromSection'] = 'actionRequiredList';

        this._sessionStorageService.saveItem('emailDetails', followupData).then(() => {
            this.dialogRefEmail = this.dialog.open(FollowUpEmail, { panelClass: 'follow-up-preview' });

            // hide ARL on preview open
            const actionRequiredListContainer = document.querySelector('#actionRequiredListContainer');
            if (actionRequiredListContainer) {
                this.renderer.setStyle(actionRequiredListContainer, 'display', 'none');
            }

            this.dialogRefEmail.afterClosed().subscribe(result => {
                // show ARL on cancel/send preview
                const actionRequiredListContainer = document.querySelector('#actionRequiredListContainer');
                if (actionRequiredListContainer) {
                    this.renderer.setStyle(actionRequiredListContainer, 'display', 'flex');
                }

                if (result && result !== 'cancel') {
                    this.loading = true;
                    const reqData = {
                        ids: [followupData.id],
                        method: 'email',
                        message: result
                    };
                    this._actionRequiredListService.sendTrigger(reqData)
                        .subscribe(res => {
                            this.loading = false;
                            this._mdlSnackbarService.showSnackbar('TRIGGER_SENT', 'success');
                            this.actionItemsArray = [followupData.id];
                            this.followupListCommunicationArray = [{
                                original_id: followupData?.related_data?.original_instance_id,
                                followup_type: followupData?.followup_type,
                            }];
                            this.loadListAfterAction();
                        },
                            error => {
                                this.loading = false;
                                this._mdlSnackbarService.showSnackbar('SOMETHING_WENT_WRONG', 'error');
                            });
                }
            });
        });
    }

    ngOnInit() {
        this._sessionStorageService.readItem(config.role).then((data: any) => {
            if (this.subscriptionAccessAllowed(data)) {
                if (this.userRole === 'COO Admin' || this.userRole === 'Location Manager') {
                    this.headerItems = this.headerItemsCOO;
                    this.initCOO();
                }
                else {
                    this.headerItems = this.headerItemsTC;
                    this.initTC();
                    for (let sort_param of this.sortParams) {
                        let newConfig = {
                            sortDescending: true,
                            firstToggle: true
                        }
                        this.sortParamsConfig[sort_param] = newConfig;
                    }
                }
            }
        });
    }

    ngOnDestroy() {
        this._restrictOutsideScrollService.showBackgroundScroll();
        this.dialogRefLtrErrorPopup?.close();
        this.dialogRefEmail?.close();
        this.dialogRefSms?.close();

        this.utilServiceSubscriptions.forEach(subscription => subscription?.unsubscribe());
    }
}
